module.exports = "../../static/img/VpitivUm.3a01cc9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about_us_main/VpitivUm.jpg
// module id = KUo2
// module chunks = 1